import styled from "styled-components";

export const _SizeViewContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  // TODO 2493 (lower prio atm) needs a better solution for e.g. iPhone X + landscape mobile
  padding-top: 44vh;

  @media (min-width: 768px) {
    padding-top: 0;
    flex-direction: row;
  }
`;

export const _LayoutSectionSizeView = styled.div`
  position: relative;

  @media (min-width: 768px) {
    width: 45%;
    padding-top: 45px;
  }

  @media (min-width: 1200px) {
    width: initial;
    flex-basis: ${(props) => props.basis || "45%"};
  }
`;

export const _NavigationContainer = styled.div`
  padding: 0px 20px;
`;

export const _VerticalSeparator = styled.div`
  width: 1px;
  background: lightgrey;
`;
